import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IAuditButtonState {}

export interface IAuditButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class AuditButton extends PureSdComponent<IAuditButtonProps & IWithSDProps, IAuditButtonState> {
  constructor(props: IAuditButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.Audit);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.Audit);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.AuditButton) === Visibility.Visible && (
          <KuikaButton
            data-testid="auditTabButton"
            data-onboarding-id="left_menu_audit"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.Audit)}
            onClick={this.handleClick}
            className="kuika_left-panel__audit-button"
          >
            <KuikaSvg type="sidebar-icons" name="double-check" width={16} height={16} pointer />
          </KuikaButton>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const auditButton = withSD<IAuditButtonProps>(AuditButton);
export { auditButton as AuditButton };
